import { Button, MuiAppBar, MuiToolbar } from "@dealer-center/core-components";
import { footerHeight, minWidth } from "@dealer-center/core-custom-components";
import { backgroundColor } from "../const";

export const bottomBarlinks = [
  {
    label: "Terms of Service",
    href: "https://www.coxautoinc.com/terms/wp-content/uploads/sites/3/Common-Customer-TOU.pdf"
  },
  {
    label: "Privacy Policy",
    href: "https://www.coxautoinc.com/privacy-statement"
  },
  { label: "Contact Us", href: "https://casfx.my.site.com/ddc/s" }
];

export const BottomBar = () => (
  <MuiAppBar
    position="relative"
    sx={{
      flexShrink: 0,
      minWidth,
      backgroundColor
    }}
  >
    <MuiToolbar
      sx={{
        display: "flex",
        gap: 2,
        minHeight: `${footerHeight}px !important`,
        justifyContent: "right",
        alignItems: "center",
        "&>button": {
          width: "auto"
        }
      }}
      variant="dense"
    >
      {bottomBarlinks.map(link => (
        <Button
          analyticsConfiguration={{
            eventName: "click",
            eventProperties: {
              component: "bottomBar",
              actionContext: "click",
              actionValue: link.label,
              errorMessage: "",
              label: link.label
            }
          }}
          buttonStyle="aux"
          key={link.label}
          sx={{ my: "4px", color: "white", display: "block" }}
          onClick={() => {
            window.open(link.href, "_blank");
          }}
        >
          {link.label}
        </Button>
      ))}
    </MuiToolbar>
  </MuiAppBar>
);
